module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/unauth-layout/unauth-layout.component.scss
// module id = ./src/app/layouts/unauth-layout/unauth-layout.component.scss
// module chunks = main